import "prebid.js/modules/medianetBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {MediaNetAdUnit} from "header-bidding-base/modules/config/domain/bidders/mediaNetConfig";

export class MediaNetBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<MediaNetAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.MEDIANET);
    }
}
